











































































































































































































































































































































































































import Vue from 'vue'
import { iotExport } from '@/api/api'
import MethodDrawer from './components/Method.vue'
import SettingDrawer from './components/Setting.vue'
import EventDrawer from './components/Event.vue'
import AttributeDrawer from './components/Attribute.vue'
import HistoryDrawer from './components/History.vue'
import RegisterModal from './components/RegisterModal.vue'
import ViewTagModal from './components/ViewTagModal.vue'

import GatewayDetail from './components/GatewayDetail.vue'

import { getLocalStorage } from '@/utils/storage'
import { columns, columnsHost, appListColumns, statusList } from './components/data'
import { getUserInfo } from '@/utils/auth'
import { throttle } from 'lodash'
import { MasterlinkTenantServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import {
  GatewayServiceProxy,
  IotAppServiceProxy,
  ProductBatchServiceProxy,
  IotAppSettingServiceProxy,
  IotAppMethodServiceProxy,
  IotAppPropertyServiceProxy,
  IotAppEventServiceProxy
} from '@/service-proxies/app-v2/iot-console.service-proxies'
import GatewayTransfer from "@/views/console/gateway-list/components/GatewayTransfer.vue";
import TransferRecord from "@/views/console/gateway-list/components/TransferRecord.vue";

const gsp = new GatewayServiceProxy()
const iasp = new IotAppServiceProxy()
const systemService = new MasterlinkTenantServiceProxy()
const batchServ = new ProductBatchServiceProxy()
const iassp = new IotAppSettingServiceProxy()
const iamsp = new IotAppMethodServiceProxy()
const iapsp = new IotAppPropertyServiceProxy()
const iaesp = new IotAppEventServiceProxy()
const recycleGateway = gsp.recycleGateway.bind(gsp) // 回收网关

export default Vue.extend({
  components: {
    TransferRecord,
    GatewayTransfer,
    MethodDrawer,
    SettingDrawer,
    EventDrawer,
    AttributeDrawer,
    HistoryDrawer,
    RegisterModal,
    ViewTagModal,
    GatewayDetail
  },
  data() {
    return {
      gatewayList: [],
      appList: [],
      leftTableScroll: 0,
      rightTableScroll: 0,
      loading: false,
      appListLoading: false,
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        filter: '',
        tenantId: undefined,
        isOnline: undefined,
        batchCode: undefined,
        workStationIdPattern: undefined
      },
      selectedRowKeys: [], //  网关列表勾选
      selectedRows: [], //  网关列表复选框勾选的数据项(所有字段的集合)
      currentGatewayCode: '', // 网关列表行选中key值
      tenants: [],
      batchList: [],
      appListFilter: {
        isOnline: undefined,
        filter: ''
      },
      currentAppCode: '', // 应用列表行选中
      currentAppId: '', // 应用列表行选中
      currentApp: {}, // 当前选中的app
      currentGatewayId: '',
      currentGateway: undefined,
      recycleGatewayVisible: false,
      targetTenantName: '',
      showTransfer: false,
      transferTeant: '',
      selectGatewayIds : [],
      tenantCode: undefined,
      cardTabKey: 'applist',
    }
  },
  computed: {
    isHost() {
      return getLocalStorage('isHost') || false
    },
    columns() {
      if (this.isHost){
        return columnsHost.map((item) => {
          return {
            ...item,
            title: this.$t(item.title)
          }
        })
      }
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    appListColumns() {
      return appListColumns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    statusList() {
      return statusList.map((item) => {
        return {
          ...item,
          label: this.$t(item.label)
        }
      })
    },
    cardTabList(){
      const applist = {
          key: 'applist',
          tab: '应用列表'
        };
      const info={
          key: 'info',
          tab: '基础信息'
        };
      return this.tenantCode==='makino'? [info,applist]:[applist]
    }
  },
  watch: {
    currentGatewayCode(val) {
      this.getAppList()
    },
  },
  async mounted() {
    this.listener()
    window.addEventListener('resize', throttle(this.listener))
    const {
      data: { records }
    } = await systemService.getTenants(undefined, 1, -1, undefined, undefined)

    this.tenants = records.map((item) => ({ label: item.tenantName, value: item.tenantId }))

    const { items } = await batchServ.getList(undefined)

    this.batchList = items.map((c) => ({ label: c.batchNo, value: c.batchNo }))


    this.tenantCode = getLocalStorage('TENANT')['tenantCode']
    this.cardTabKey = this.tenantCode==='makino'? 'info':'applist'
  },
  created() {
    this.getGatewayList()

  },
  destroyed() {
    window.removeEventListener('resize', throttle(this.listener))
  },
  methods: {
    exportTable() {
      let { filter, tenantId, isOnline, batchCode, workStationIdPattern } = this.pagination
      const loginTenantId = this.getTenantId()
      const ids = this.gatewayList
        .filter((res) => this.selectedRowKeys.indexOf(res.code) != -1)
        .map((item) => item.id)
      let params: any = {
        filter: filter,
        idList: ids,
        workStationIdPattern: workStationIdPattern,
        tenantId: loginTenantId === '000000' ? tenantId : loginTenantId,
        isOnline: String(isOnline) === '1' ? true : String(isOnline) === '0' ? false : undefined,
        batchCode
      }
      iotExport(params).then((res) => {
        var a = document.createElement('a')
        a.download = `${this.$t('page_devices_management')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    },

    listener() {
      this.$nextTick(() => {
        let allH: number = document.body.clientHeight
        let conH: number = allH - 54 - 24 - 16 - 40 - 14 - 9
        this.leftTableScroll = conH - 39 - 56.5 - 15
        this.rightTableScroll = conH - 29 - 48 - 40 - 39 - 16
      })
    },
    handleChange(value, key) {
      const newData = [...this.gatewayList]
      const target = newData.find((item) => key === item.code)
      if (target) {
        target['name'] = value
        this.gatewayList = newData
      }
    },
    check(key) {
      const newData = [...this.gatewayList]
      const target = newData.find((item) => key === item.code)
      if (target) {
        target['editable'] = false
        this.gatewayList = newData
        const body: any = {
          gatewayId: target.id,
          name: target.name
        }
        gsp.updateGateway(body).then(() => {
          this.$message.success(this.$t('page_my_document_updatesucess'))
          this.getGatewayList()
        })
      }
    },
    edit(key) {
      const newData = [...this.gatewayList]
      const target = newData.find((item) => key === item.code)
      if (target) {
        target['editable'] = true
        this.gatewayList = newData
      }
    },
    handleTableChange(current: number, pageSize: number) {
      const pager = {
        pageSize: pageSize,
        current: current
      }
      Object.assign(this.pagination, pager)
      this.getGatewayList()
    },
    showSizeChange(current: number, pageSize: number) {
      const pager = {
        pageSize: pageSize,
        current: current
      }
      Object.assign(this.pagination, pager)
      this.getGatewayList()
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    // 表格勾选
    onSelectChange(selectedRowKeys: [], selectedRows: []) {
      console.log('勾选：', selectedRowKeys, selectedRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      if (this.selectedRows){
        this.selectGatewayIds = this.selectedRows.map( item => item.id )
      }
    },
    // 表格行点击
    rowClick(record: any, type: string) {
      return {
        on: {
          click: (event: any) => {
            if (type === 'currentGatewayCode') {
              this.currentGatewayCode = record.code
              this.currentGatewayId = record.id
              this.selectedRowKeys = [record.code]
              this.selectGatewayIds = [record.id]
              this.selectedRows = [record]
              this.currentGateway = record
            } else if (type === 'currentAppCode') {
              this.currentAppCode = record.code
              this.currentAppId = record.id
              this.currentApp = record
            }
            // console.log('行点击：', this.currentGatewayCode, this.selectedRowKeys, this.selectedRows)
          }
        }
      }
    },
    getTenantId() {
      const info = getUserInfo()
      return info.tenant_id || ''
    },
    // 获取网关列表
    async getGatewayList(reload?) {
      const loginTenantId = this.getTenantId()
      if (reload) {
        this.pagination.current = 1
      }
      this.gatewayList = []
      this.currentGatewayCode = ''
      this.currentGatewayId = ''
      let { current, filter, pageSize, tenantId, isOnline, batchCode, workStationIdPattern } =
        this.pagination
      let params: any = {
        current: current,
        filter: filter,
        size: pageSize,
        workStationIdPattern: workStationIdPattern,
        tenantId: loginTenantId === '000000' ? tenantId : loginTenantId,
        isOnline: String(isOnline) === '1' ? true : String(isOnline) === '0' ? false : undefined,
        batchCode,
        ascs: undefined,
        descs: undefined
      }
      this.loading = true
      try {
        let { items, totalCount } = await gsp.findGatewayList(params)
        this.pagination.total = totalCount
        this.gatewayList = items
        if (this.gatewayList && this.gatewayList.length) {
          this.gatewayList.map((item, index) => {
            if (item.associateWorkStations && item.associateWorkStations.length) {
              this.gatewayList[index].associateWorkStations =
                this.gatewayList[index].associateWorkStations.join()
            }
          })
        }
        if (this.gatewayList.length) {
          this.currentGatewayCode = this.gatewayList[0].code
          this.currentGatewayId = this.gatewayList[0].id
          this.selectedRowKeys = [this.gatewayList[0].code]
          this.selectGatewayIds = [this.gatewayList[0].id]
          this.selectedRows = [this.gatewayList[0]]
          this.currentGateway=this.gatewayList[0]
        } else {
          this.currentGatewayCode = ''
          this.currentGatewayId = ''
          this.selectedRowKeys = []
          this.selectGatewayIds = []
          this.selectedRows = []
        }
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    // 获取应用列表
    async getAppList() {
      this.appList = []
      this.appListLoading = true
      const { isOnline, filter } = this.appListFilter
      let status = String(isOnline) === '1' ? true : String(isOnline) === '0' ? false : undefined
      try {
        let { items } = await iasp.getIotAppList(filter, this.currentGatewayCode, status)
        this.appList = items
        this.currentApp = this.appList.length ? this.appList[0] : {}
        this.currentAppCode = this.appList.length ? this.appList[0].code : ''
        this.currentAppId = this.appList.length ? this.appList[0].id : ''
      } catch (e) {
        console.log(e)
      }
      this.appListLoading = false
    },
    openRegisterModal() {
      this.$refs.registerModal.trigger()
    },
    // 回收网关
    async recycleGateway() {
      let ids = this.selectedRows.map((item) => item.id)
      let params = {
        gatewayIdList: ids,
        targetTenantName: this.targetTenantName
      }
      try {
        await recycleGateway(params)
        this.$message.success(this.$t('page_resource_pool_success'))
        this.recycleGatewayVisible = false
        this.getGatewayList(true)
      } catch (e) {
        console.log(e)
      }
    },
    // 查看标签
    viewTag(record: any) {
      this.currentGatewayId = record.id
      this.$nextTick(() => {
        this.$refs.viewTagModal.openViewDialog()
      })
    },
    showDrawer() {
      this.$refs.Method.showDrawer()
    },
    showSet() {
      this.$refs.Set.showDrawer()
    },
    showEvent() {
      this.$refs.Event.showDrawer()
    },
    showQuality() {
      this.$refs.Quality.showDrawer()
    },
    showHistory() {
      this.$refs.History.showDrawer()
    },
    async toggleAppStatus(type) {
      let fn = {
        start: iasp.startIotApp.bind(iasp),
        stop: iasp.stopIotApp.bind(iasp)
      }
      await fn[type](this.currentGatewayCode, this.currentAppCode)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.getAppList()
    },
    // 切换app监控状态
    async toggleAppLogMonitoring(type) {
      let params = {
        appCode: this.currentAppCode,
        enabled: type,
        gatewayCode: this.currentGatewayCode
      }
      let fn = iasp.monitorLog.bind(iasp, params)

      await fn()
      this.$message.success(this.$t('page_resource_pool_success'))
      this.getAppList()
    },
    // 同步
    async synchro(child) {
      let params = {
        appCode: this.currentAppCode,
        gatewayCode: this.currentGatewayCode
      }
      let fn = {
        Set: iassp.requestIotSettingMetadata.bind(iassp),
        Quality: iapsp.requestIotPropertyMetadata.bind(iapsp),
        Method: iamsp.requestIotMethodMetadata.bind(iamsp),
        Event: iaesp.requestIotEventMetadata.bind(iaesp)
      }
      await fn[child](params)
      this.$message.success(this.$t('page_resource_pool_success'))
      this.$refs[child].refresh()
    },
    trigger() {
      this.recycleGatewayVisible = !this.recycleGatewayVisible
      this.targetTenantName = ''
    }
  }
})
